// @flow

const getConfiguration = (props: any) => {
    return {
        enableToolbar: true,
        enableToolbarSearchField: false,
        enableHeader: false,
        enablePagination: false,

        showItemActions: false,

        enableItemSelection: false,
    };
}
export default getConfiguration;